import { graphql } from '../graphql/generated';

export const MARK_AIS_EXPORTED_MUTATION = graphql(`
  mutation MarkAisExported($requestId: ID!, $orderIds: [ID!]!) {
    markAisExported(requestId: $requestId, orderIds: $orderIds) {
      id
    }
  }
`);
